import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://0486da49979585bcbfec9d57bdf0bc39@o4509552379428864.ingest.de.sentry.io/4509558501474384",
  debug: false,
  environment: "production",
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 0.2,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});